import { createFileRoute, useSearch } from '@tanstack/react-router'
import { QuizBusinessView, TopicsQuizView } from '@unsw/features/workshops'

type QuizBusinessSearch = {
  unit?: string
  case_study?: string
  quiz_id?: string
}

export const Route = createFileRoute('/dashboard/quiz-business')({
  component: QuizBusinessPage,
  validateSearch: (search: Record<string, unknown>): QuizBusinessSearch => ({
    unit: search.unit ? String(search.unit) : undefined,
    case_study: search.case_study ? String(search.case_study) : undefined,
    quiz_id: search.quiz_id ? String(search.quiz_id) : undefined,
  }),
})

function QuizBusinessPage() {
  const { unit, case_study, quiz_id } = useSearch({ from: '/dashboard/quiz-business' })

  return unit || case_study || quiz_id ? <QuizBusinessView /> : <TopicsQuizView />
}
